function ListSeparator() {
  return <div className="list-item-separator" />;
}

export default ListSeparator;
